const memberFiles = require.context(
    "@/components/project-module/forms",
    true,
    /\.vue$/,
);

const components = [];
for (const file of memberFiles.keys()) {
    const name = file.replace(/^\.\//, "").replace(/\.\w+$/, "");
    components.push([
        `fpm-${name}`,
        import(`@/components/project-module/forms/${name}.vue`),
    ]);
}

export default {
    async install(Vue) {
        for (const [file, exported] of components) {
            Vue.component(file, (await exported).default);
        }
    },
};
